module.exports = __webpack_public_path__ + "static/accessible-logo-765c80752a8c1a3ed1078f362de01d6e.png";